import { Controller } from "@hotwired/stimulus"

const COOKIE_NAME = "dismissed_announcements"
const MAX_IDS = 20
const MAX_AGE = 60 * 60 * 24 * 180 // 180 days

export default class extends Controller {
  static values = { id: Number }

  dismiss(event) {
    event.preventDefault()

    const ids = this.dismissedIds()
    const id = String(this.idValue)

    if (!ids.includes(id)) ids.push(id)

    document.cookie = `${COOKIE_NAME}=${ids.slice(-MAX_IDS).join(",")}; path=/; max-age=${MAX_AGE}; SameSite=Lax`
    this.element.remove()
  }

  dismissedIds() {
    const entry = document.cookie
      .split("; ")
      .find((row) => row.startsWith(`${COOKIE_NAME}=`))

    if (!entry) return []

    return entry.slice(COOKIE_NAME.length + 1).split(",").filter(Boolean)
  }
}
